import moment from "moment";

export const columns = [
  {
    accessorKey: "printReport",
    header: "Print",
    size: 160,
  },
  {
    accessorKey: "sNo",
    header: "S No",
    size: 130,
    accessorFn: (row: any, index: any) => index + 1,
  },
  {
    accessorKey: "blNo",
    header: "BL No",
    size: 130,
  },
  {
    accessorKey: "virNo",
    header: "VIR No",
    size: 170,
  },
  {
    accessorKey: "gateInTime",
    header: "Gate in Time",
    size: 190,
    accessorFn: (row: any) =>
      row.gateInTime ? moment(row.gateInTime).format("DD-MM-YYYY hh:mm:ss A") : "",
  },
  {
    accessorKey: "indexNumber",
    header: "Index No",
    size: 150,
  },
  {
    accessorKey: "consignee",
    header: "Consignee",
    size: 150,
  },
  {
    accessorKey: "description",
    header: "Description",
    size: 150,
  },
  {
    accessorKey: "markAndNumber",
    header: "Mark And Number",
    size: 150,
  },
  {
    accessorKey: "cargoType",
    header: "Cargo Type",
    size: 210,
  },
  {
    accessorKey: "chasisNumbers",
    header: "Chassis Numbers",
    size: 210,
  },
  {
    accessorKey: "manifCBM",
    header: "Manifested CBM",
    size: 210,
  },
  {
    accessorKey: "noOfPackages",
    header: "Manifested Packages",
    size: 210,
  },
  {
    accessorKey: "packageType",
    header: "Package Type",
    size: 210,
  },
  {
    accessorKey: "manifWeight",
    header: "Manifested Weight",
    size: 210,
  },
  {
    accessorKey: "destuffCBM",
    header: "Destuff CBM",
    size: 210,
  },
  {
    accessorKey: "destuffPackages",
    header: "Destuff Packages",
    size: 210,
  },
  {
    accessorKey: "destuffWeight",
    header: "Destuff Weight",
    size: 210,
  },
  {
    accessorKey: "destuffInv",
    header: "Destuff Inv",
    size: 210,
  },
  {
    accessorKey: "destuffPL",
    header: "Destuff P.L",
    size: 210,
  },
  {
    accessorKey: "locationName",
    header: "Location Name",
    size: 210,
  },
  {
    accessorKey: "shortCBM",
    header: "Short CBM",
    size: 200,
  },
  {
    accessorKey: "shortPackages",
    header: "Short Packages",
    size: 200,
  },
  {
    accessorKey: "shortWeight",
    header: "Short Weight",
    size: 200,
  },
  {
    accessorKey: "indexRemarks",
    header: "Remarks",
    size: 150,
  },
  {
    accessorKey: "statusId",
    header: "Item Status",
    size: 210,
  },
  // {
  //   accessorKey: "actions",
  //   header: "Action",
  //   size: 150,
  // },
  {
    accessorKey: "reset",
    header: "Action",
    size: 100,
  },
];
